import { render, staticRenderFns } from "./configAutoReply.vue?vue&type=template&id=68e1ecba&scoped=true&"
import script from "./configAutoReply.vue?vue&type=script&lang=js&"
export * from "./configAutoReply.vue?vue&type=script&lang=js&"
import style0 from "./configAutoReply.vue?vue&type=style&index=0&id=68e1ecba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e1ecba",
  null
  
)

export default component.exports